import { JobFailure } from '../../../interfaces/job';
import { Banner } from '../../../../banner/Banner';
import { ExpandableContent } from '../../../../shared/components/ExpandableContent/ExpandableContent';

export function JobFailureBanner({ jobFailures }: { jobFailures: JobFailure[] }) {
  return (
    <Banner open dataId='job-failure-banner' icon='error-outline' color='error' className='mb-5'>
      <span className='text-medium'>
        Job failed due to following reason{jobFailures.length > 1 ? 's' : ''}
        :&nbsp;
      </span>

      <ExpandableContent>
        {jobFailures.length > 1 ? <br /> : null}

        {jobFailures.length === 1 ? (
          <span>{jobFailures[0].reason}</span>
        ) : (
          <ul className='mt-1 pl-3'>
            {jobFailures.map(failure => (
              <li key={failure.id}>{failure.reason}&nbsp;</li>
            ))}
          </ul>
        )}
      </ExpandableContent>
    </Banner>
  );
}
